module.exports = __webpack_public_path__ + "static/fonts/Roboto-Medium.9a3bf7a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/fonts/Roboto-Medium/Roboto-Medium.woff
// module id = HMg2
// module chunks = 24